import React from 'react'
import {Box, Text, Flex} from '../../../../../vanilla'
import {toggleButtonRecipe} from './style.css'
import {ChannelConsent} from '../../../../../store/MarketingPreferencesStore'

type PreferenceToggleProps = {
  label: string
  name: string
  consent: ChannelConsent
  onToggle: (name: string, value: 'Opt In' | 'Opt Out') => void
}

export const PreferenceToggle: React.FC<PreferenceToggleProps> = ({
  label,
  name,
  consent,
  onToggle
}) => {
  const buttonClassName = toggleButtonRecipe()

  return (
    <Flex
      as="label"
      align="center"
      justifyContent="space-between"
      data-test-selector="preference-toggle-container"
    >
      <Text as="span" variant="text3" data-test-selector="preference-toggle-label">
        {label}
      </Text>
      <Flex align="center" gap="20px" data-test-selector="preference-toggle-buttons">
        <Box
          as="button"
          type="button"
          onClick={() => onToggle(name, 'Opt In')}
          aria-pressed={consent === ChannelConsent.OPT_IN}
          className={`${buttonClassName}${consent === ChannelConsent.OPT_IN ? ' checked' : ''}`}
          aria-label={`${label} - Opt In`}
          data-test-selector="preference-toggle-opt-in-button"
        />
        <Box
          as="button"
          type="button"
          onClick={() => onToggle(name, 'Opt Out')}
          aria-pressed={consent === ChannelConsent.OPT_OUT}
          className={`${buttonClassName}${consent === ChannelConsent.OPT_OUT ? ' checked' : ''}`}
          aria-label={`${label} - Opt Out`}
          data-test-selector="preference-toggle-opt-out-button"
        />
      </Flex>
    </Flex>
  )
}
